(function () {
  'use strict';

  var root;
  var panel;
  var refreshPromise;
  var giftSyncing = false;
  var lastFocused;
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var productCache = {};

  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      style: 'currency',
      currency: currency
    }).format((Number(cents) || 0) / 100);
  }

  function escapeHtml(value) {
    var node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  }

  function imageUrl(url, width) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', width);
      return parsed.toString();
    } catch (error) {
      return url;
    }
  }

  function request(url, options) {
    var config = options || {};
    config.headers = Object.assign({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, config.headers || {});
    if (typeof fetch === 'function') return fetch(url, config).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          throw new Error(body.description || body.message || 'Erreur panier');
        });
      }
      return response.json();
    });

    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(config.method || 'GET', url);
      Object.keys(config.headers).forEach(function (key) {
        xhr.setRequestHeader(key, config.headers[key]);
      });
      xhr.onload = function () {
        var body = {};
        try {
          body = xhr.responseText ? JSON.parse(xhr.responseText) : {};
        } catch (error) {
          body = {};
        }
        if (xhr.status < 200 || xhr.status >= 300) {
          reject(new Error(body.description || body.message || 'Erreur panier'));
          return;
        }
        resolve(body);
      };
      xhr.onerror = function () {
        reject(new Error('Erreur panier'));
      };
      xhr.send(config.body || null);
    });
  }

  function productHandle(item) {
    var url = item.url || '';
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function productData(item) {
    var handle = productHandle(item);
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = request('/products/' + handle + '.js').catch(function () { return null; });
    }
    return productCache[handle];
  }

  function variantCompareAt(item, product) {
    if (!product || !product.variants) return 0;
    var variant = product.variants.find(function (entry) {
      return Number(entry.id) === Number(item.variant_id);
    });
    return variant ? Number(variant.compare_at_price || 0) : 0;
  }

  function isGift(item) {
    return Boolean(item.properties && (item.properties._gift === true || item.properties._gift === 'true'));
  }

  function qualifyingTotal(cart) {
    return cart.items.reduce(function (total, item) {
      return total + (isGift(item) ? 0 : Number(item.final_line_price || 0));
    }, 0);
  }

  function cartSavings(cart) {
    return cart.items.reduce(function (total, item) {
      var original = Number(item.original_line_price || 0);
      if (!original && Number(item.original_price || 0) > Number(item.final_price || 0)) {
        original = Number(item.original_price || 0) * Number(item.quantity || 1);
      }
      var finalPrice = Number(item.final_line_price || 0);
      return total + Math.max(0, original - finalPrice);
    }, 0);
  }

  function compareAtSavings(cart) {
    return Promise.all(cart.items.map(function (item) {
      if (isGift(item)) return Promise.resolve(0);
      return productData(item).then(function (product) {
        var compareAt = variantCompareAt(item, product);
        var finalUnit = Number(item.final_price || 0);
        if (compareAt <= finalUnit) return 0;
        return (compareAt - finalUnit) * Number(item.quantity || 1);
      });
    })).then(function (lines) {
      return lines.reduce(function (total, value) { return total + value; }, 0);
    });
  }

  function bestLineComparePrice(item, product) {
    if (isGift(item)) return 0;
    var finalLine = Number(item.final_line_price || 0);
    var originalLine = Number(item.original_line_price || 0);
    var compareAt = variantCompareAt(item, product);
    var variantCompareLine = compareAt > 0 ? compareAt * Number(item.quantity || 1) : 0;
    return Math.max(originalLine, variantCompareLine) > finalLine
      ? Math.max(originalLine, variantCompareLine)
      : 0;
  }

  function priceMarkup(item, compareLinePrice) {
    var hasCompare = Number(compareLinePrice || 0) > Number(item.final_line_price || 0);
    if (isGift(item)) {
      return '<div class="kc-price price price--on-sale" data-ky-line-price><span class="price-item price-item--sale">Offert</span>'
        + (hasCompare ? '<s class="price-item price-item--regular">' + money(compareLinePrice) + '</s>' : '')
        + '</div>';
    }
    return '<div class="kc-price price' + (hasCompare ? ' price--on-sale' : '') + '" data-ky-line-price>'
      + '<span class="price-item ' + (hasCompare ? 'price-item--sale' : 'price-item--regular') + '">' + money(item.final_line_price) + '</span>'
      + (hasCompare ? '<s class="price-item price-item--regular">' + money(compareLinePrice) + '</s>' : '')
      + '</div>';
  }

  function updateLineComparePrices(cart) {
    if (!root || !cart || !cart.items) return;
    cart.items.forEach(function (item, index) {
      if (isGift(item)) return;
      productData(item).then(function (product) {
        var compareLinePrice = bestLineComparePrice(item, product);
        if (!compareLinePrice) return;
        var line = root.querySelector('[data-line-index="' + index + '"]');
        if (!line || line.dataset.lineKey !== item.key) return;
        var node = line.querySelector('[data-ky-line-price]');
        if (node) node.outerHTML = priceMarkup(item, compareLinePrice);
      });
    });
  }

  function updateCounts(cart) {
    document.querySelectorAll('[data-ky-cart-count], [data-cart-count], [data-ky-cart-bubble]').forEach(function (node) {
      node.textContent = cart.item_count;
      node.hidden = cart.item_count === 0;
    });
  }

  function lineSubline(item) {
    if (item.variant_title && item.variant_title !== 'Default Title') return item.variant_title;
    if (item.options_with_values && item.options_with_values.length) {
      return item.options_with_values
        .map(function (option) { return option.value; })
        .filter(function (value) { return value && value !== 'Default Title'; })
        .join(' · ');
    }
    return '';
  }

  function updateSavings(cart, baseSavings) {
    var savingsRow = root.querySelector('[data-ky-cart-savings]');
    if (!savingsRow) return;
    var value = root.querySelector('[data-ky-cart-savings-value]');
    var apply = function (savings) {
      savingsRow.hidden = root.dataset.showSavings !== 'true' || savings <= 0;
      if (value) value.textContent = '− ' + money(savings);
    };

    apply(baseSavings);
    compareAtSavings(cart).then(function (compareSavings) {
      apply(Math.max(baseSavings, compareSavings));
    });
  }

  function lineMarkup(item, index) {
    var gift = isGift(item);
    var image = item.image
      ? '<img src="' + escapeHtml(imageUrl(item.image, 160)) + '" alt="' + escapeHtml(item.product_title) + '" width="64" height="64">'
      : '';
    var compare = bestLineComparePrice(item, null);
    var controls = gift
      ? '<span class="kc-gift-tag">Offert · dès ' + escapeHtml(Number(root.dataset.giftAt || 0) / 100) + '€</span>'
      : '<div class="kc-qty"><button type="button" data-ky-line-delta="-1" aria-label="Réduire la quantité">−</button><span>' + item.quantity + '</span><button type="button" data-ky-line-delta="1" aria-label="Augmenter la quantité">+</button></div>';
    var price = priceMarkup(item, compare);
    var remove = gift ? '' : '<button class="kc-rm" type="button" data-ky-line-remove aria-label="Retirer">✕</button>';

    return '<article class="kc-item' + (gift ? ' is-gift' : '') + '" data-line-key="' + escapeHtml(item.key) + '" data-line-index="' + index + '" data-line-quantity="' + item.quantity + '">'
      + '<a class="kc-thumb" href="' + escapeHtml(item.url) + '">' + image + '</a>'
      + '<div class="kc-meta"><a class="kc-nm" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>'
      + (gift ? controls : '<div class="kc-sub">' + escapeHtml(lineSubline(item)) + '</div>')
      + '<div class="kc-row">' + (gift ? '<span></span>' : controls) + price + '</div></div>' + remove + '</article>';
  }

  function renderThreshold(cart) {
    var threshold = root.querySelector('[data-ky-threshold]');
    if (!threshold || root.dataset.thresholdMode === 'off') return;

    var mode = root.dataset.thresholdMode;
    var total = qualifyingTotal(cart);
    var freeAt = 0; /* soldes 2026-07-11: livraison offerte partout */
    var giftAt = Number(root.dataset.giftAt || 5900);
    var scaleAt = mode === 'single' ? freeAt : giftAt;
    var percent = scaleAt > 0 ? Math.min(100, total / scaleAt * 100) : 100;
    var message;

    if (total === 0) {
      message = 'Votre panier est vide - ajoutez une pierre pour commencer.';
    } else if (total < freeAt) {
      message = 'Plus que <b>' + money(freeAt - total) + '</b> pour la <b>livraison offerte dès ' + freeAt / 100 + '€</b>';
    } else if (mode === 'single') {
      message = 'Livraison offerte ✓';
    } else if (total < giftAt) {
      message = 'Livraison offerte ✓ · plus que <b>' + money(giftAt - total) + '</b> pour le <b>bracelet offert</b>';
    } else {
      message = 'Bracelet offert ajouté ✓';
    }

    threshold.classList.toggle('is-unlocked', total >= (mode === 'single' ? freeAt : giftAt));
    var messageNode = root.querySelector('[data-ky-threshold-message]');
    var barNode = root.querySelector('[data-ky-threshold-bar]');
    if (messageNode) messageNode.innerHTML = message;
    if (barNode) barNode.style.width = percent + '%';

    var shipTick = root.querySelector('[data-ky-ship-tick]');
    var giftTick = root.querySelector('[data-ky-gift-tick]');
    if (shipTick) {
      shipTick.classList.toggle('is-reached', total >= freeAt);
      shipTick.textContent = 'Livraison offerte ✓';
    }
    if (giftTick) {
      giftTick.classList.toggle('is-reached', total >= giftAt);
      giftTick.textContent = 'Bracelet offert · ' + giftAt / 100 + '€' + (total >= giftAt ? ' ✓' : '');
    }
  }

  function render(cart) {
    if (!root) return cart;
    var hasItems = cart.item_count > 0;
    var lines = root.querySelector('[data-ky-cart-lines]');
    var empty = root.querySelector('[data-ky-cart-empty]');
    var footer = root.querySelector('[data-ky-cart-footer]');
    var savings = cartSavings(cart);

    updateCounts(cart);
    lines.hidden = !hasItems;
    empty.hidden = hasItems;
    footer.hidden = !hasItems;
    lines.innerHTML = cart.items.map(lineMarkup).join('');
    root.querySelector('[data-ky-cart-total]').textContent = money(cart.total_price);

    updateSavings(cart, savings);
    updateLineComparePrices(cart);

    root.querySelectorAll('[data-ky-xsell] [data-product-id]').forEach(function (node) {
      node.hidden = cart.items.some(function (item) {
        return String(item.product_id) === node.dataset.productId;
      });
    });

    renderThreshold(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('ky:cart:updated', { detail: { cart: cart } }));
    return cart;
  }

  function syncGift(cart) {
    var mode = root.dataset.thresholdMode;
    var giftVariantId = Number(root.dataset.giftVariantId || 0);
    if (mode !== 'dual' || !giftVariantId || giftSyncing) return Promise.resolve(cart);

    var giftAt = Number(root.dataset.giftAt || 5900);
    var shouldHaveGift = qualifyingTotal(cart) >= giftAt;
    var giftLine = cart.items.find(isGift);
    if (shouldHaveGift === Boolean(giftLine) && (!giftLine || giftLine.quantity === 1)) return Promise.resolve(cart);

    giftSyncing = true;
    var mutation = shouldHaveGift && !giftLine
      ? request('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({ items: [{ id: giftVariantId, quantity: 1, properties: { _gift: 'true' } }] })
        }).then(function () { return request('/cart.js'); })
      : request('/cart/change.js', {
          method: 'POST',
          body: JSON.stringify({ id: giftLine.key, quantity: shouldHaveGift ? 1 : 0 })
        });

    return mutation.finally(function () { giftSyncing = false; });
  }

  function refresh() {
    if (!root) return Promise.reject(new Error('Tiroir panier indisponible'));
    if (refreshPromise) return refreshPromise;
    refreshPromise = request('/cart.js')
      .then(syncGift)
      .then(render)
      .finally(function () { refreshPromise = null; });
    return refreshPromise;
  }

  function pulse() {
    var icon = document.querySelector('[data-kn-cart-open], [data-ky-cart-open], .kn-ico[aria-label="Panier"]');
    if (!icon) return;
    icon.classList.remove('kc-pulse');
    void icon.offsetWidth;
    icon.classList.add('kc-pulse');
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  function open() {
    if (!root) return;
    var navDrawer = document.querySelector('.kn-drawer.open');
    if (navDrawer) {
      navDrawer.classList.add('kn-no-anim');
    }
    emit('ky:nav:close');
    window.setTimeout(function () {
      if (navDrawer) navDrawer.classList.remove('kn-no-anim');
    }, 60);
    lastFocused = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    window.setTimeout(function () { panel.focus(); }, 30);
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function giftLineForProjectedCart(cartBefore, mainVariantId, addedTotal, properties) {
    if (!root || root.dataset.thresholdMode !== 'dual') return null;
    if (properties && (properties._gift === true || properties._gift === 'true')) return null;

    var giftVariantId = Number(root.dataset.giftVariantId || 0);
    if (!giftVariantId || Number(mainVariantId) === giftVariantId) return null;

    var giftAt = Number(root.dataset.giftAt || 5900);
    var currentTotal = cartBefore ? qualifyingTotal(cartBefore) : 0;
    var hasGift = cartBefore && cartBefore.items && cartBefore.items.some(isGift);
    if (hasGift || currentTotal + Number(addedTotal || 0) < giftAt) return null;

    return { id: giftVariantId, quantity: 1, properties: { _gift: 'true' } };
  }

  function add(variantId, quantity, properties, lineTotal) {
    var id = typeof variantId === 'object' ? variantId.id : variantId;
    var qty = typeof variantId === 'object' ? variantId.quantity : quantity;
    var props = typeof variantId === 'object' ? variantId.properties : properties;
    var addedTotal = typeof variantId === 'object'
      ? Number(variantId.lineTotal || variantId.totalPrice || 0)
      : Number(lineTotal || 0);
    var mainLine = { id: Number(id), quantity: Number(qty) || 1, properties: props || {} };

    return request('/cart.js').catch(function () { return null; }).then(function (cartBefore) {
      var items = [mainLine];
      var giftLine = giftLineForProjectedCart(cartBefore, id, addedTotal, mainLine.properties);
      if (giftLine) items.push(giftLine);
      return request('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items: items })
      });
    }).then(function () {
      pulse();
      return refresh();
    }).then(function (cart) {
      emit('ky:cart:open');
      return cart;
    });
  }

  function changeLine(lineOrKey, quantity) {
    var payload = typeof lineOrKey === 'number'
      ? { line: lineOrKey, quantity: Math.max(0, Number(quantity) || 0) }
      : { id: lineOrKey, quantity: Math.max(0, Number(quantity) || 0) };
    return request('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify(payload)
    }).then(syncGift).then(render);
  }

  function onClick(event) {
    if (event.target.closest('[data-ky-cart-close]')) {
      close();
      return;
    }

    var opener = event.target.closest('[data-ky-cart-open]');
    if (opener) {
      event.preventDefault();
      open();
      refresh();
      return;
    }

    var addButton = event.target.closest('[data-ky-cart-add]');
    if (addButton) {
      addButton.disabled = true;
      add(addButton.dataset.kyCartAdd, 1).catch(function (error) {
        console.error(error);
      }).finally(function () {
        addButton.disabled = false;
      });
      return;
    }

    var line = event.target.closest('[data-line-key]');
    if (!line) return;
    var delta = event.target.closest('[data-ky-line-delta]');
    var remove = event.target.closest('[data-ky-line-remove]');
    if (!delta && !remove) return;
    var quantity = remove ? 0 : Number(line.dataset.lineQuantity) + Number(delta.dataset.kyLineDelta);
    event.target.disabled = true;
    changeLine(line.dataset.lineKey, quantity).catch(function () {
      event.target.disabled = false;
    });
  }

  function init() {
    root = document.getElementById('KyCartDrawer');
    if (!root || root.dataset.kyCartReady === 'true') return;
    root.dataset.kyCartReady = 'true';
    panel = root.querySelector('.kycart');
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) close();
    });
    document.addEventListener('ky:cart:open', function () {
      open();
      refresh();
    });
    document.addEventListener('ky:cart:refresh', function () {
      refresh();
    });
  }

  window.KYCart = {
    open: open,
    close: close,
    add: add,
    changeLine: changeLine,
    refresh: refresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
